/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileUrl } from './FileUrl';
import { FileUrlFromJSON, FileUrlFromJSONTyped, FileUrlToJSON } from './FileUrl';
import type { Html } from './Html';
import { HtmlFromJSON, HtmlFromJSONTyped, HtmlToJSON } from './Html';
import type { Published } from './Published';
import { PublishedFromJSON, PublishedFromJSONTyped, PublishedToJSON } from './Published';
import type { UpdatedAt } from './UpdatedAt';
import { UpdatedAtFromJSON, UpdatedAtFromJSONTyped, UpdatedAtToJSON } from './UpdatedAt';
import type { UpdatedBy } from './UpdatedBy';
import { UpdatedByFromJSON, UpdatedByFromJSONTyped, UpdatedByToJSON } from './UpdatedBy';

/**
 *
 * @export
 * @interface ArticleAdminModel
 */
export interface ArticleAdminModel {
    /**
     *
     * @type {string}
     * @memberof ArticleAdminModel
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof ArticleAdminModel
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof ArticleAdminModel
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof ArticleAdminModel
     */
    author: string;
    /**
     *
     * @type {Date}
     * @memberof ArticleAdminModel
     */
    publishOn: Date;
    /**
     *
     * @type {Published}
     * @memberof ArticleAdminModel
     */
    published?: Published;
    /**
     *
     * @type {Date}
     * @memberof ArticleAdminModel
     */
    createdAt: Date;
    /**
     *
     * @type {UpdatedAt}
     * @memberof ArticleAdminModel
     */
    updatedAt?: UpdatedAt;
    /**
     *
     * @type {string}
     * @memberof ArticleAdminModel
     */
    createdBy: string;
    /**
     *
     * @type {UpdatedBy}
     * @memberof ArticleAdminModel
     */
    updatedBy?: UpdatedBy;
    /**
     *
     * @type {string}
     * @memberof ArticleAdminModel
     */
    content: string;
    /**
     *
     * @type {Html}
     * @memberof ArticleAdminModel
     */
    html?: Html;
    /**
     *
     * @type {FileUrl}
     * @memberof ArticleAdminModel
     */
    fileUrl?: FileUrl;
}

/**
 * Check if a given object implements the ArticleAdminModel interface.
 */
export function instanceOfArticleAdminModel(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('title' in value)) return false;
    if (!('type' in value)) return false;
    if (!('author' in value)) return false;
    if (!('publishOn' in value)) return false;
    if (!('createdAt' in value)) return false;
    if (!('createdBy' in value)) return false;
    if (!('content' in value)) return false;
    return true;
}

export function ArticleAdminModelFromJSON(json: any): ArticleAdminModel {
    return ArticleAdminModelFromJSONTyped(json, false);
}

export function ArticleAdminModelFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ArticleAdminModel {
    if (json == null) {
        return json;
    }
    return {
        id: json['id'],
        title: json['title'],
        type: json['type'],
        author: json['author'],
        publishOn: new Date(json['publish_on']),
        published: json['published'] == null ? undefined : PublishedFromJSON(json['published']),
        createdAt: new Date(json['created_at']),
        updatedAt: json['updated_at'] == null ? undefined : UpdatedAtFromJSON(json['updated_at']),
        createdBy: json['created_by'],
        updatedBy: json['updated_by'] == null ? undefined : UpdatedByFromJSON(json['updated_by']),
        content: json['content'],
        html: json['html'] == null ? undefined : HtmlFromJSON(json['html']),
        fileUrl: json['file_url'] == null ? undefined : FileUrlFromJSON(json['file_url']),
    };
}

export function ArticleAdminModelToJSON(value?: ArticleAdminModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        id: value['id'],
        title: value['title'],
        type: value['type'],
        author: value['author'],
        publish_on: value['publishOn'].toISOString(),
        published: PublishedToJSON(value['published']),
        created_at: value['createdAt'].toISOString(),
        updated_at: UpdatedAtToJSON(value['updatedAt']),
        created_by: value['createdBy'],
        updated_by: UpdatedByToJSON(value['updatedBy']),
        content: value['content'],
        html: HtmlToJSON(value['html']),
        file_url: FileUrlToJSON(value['fileUrl']),
    };
}
